import PropTypes from 'prop-types';
import React from 'react';

import { Accordion } from '~/eds/src/components/Accordion/Accordion';
import { Box } from '~/eds/src/components/Box/Box';

function SignStageItems({ items }) {
  return (
    <Accordion
      padding="all"
      items={items.map((item, index) => ({
        key: index,
        title: item.title,
        content: <Box pt={4}>{item.content}</Box>,
        headerBorder: 'bottom',
        isExpanded: true,
      }))}
    />
  );
}

SignStageItems.propTypes = {
  /** Array of item objects */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      /** Item id */
      id: PropTypes.string,
      /** Item title text */
      title: PropTypes.string,
      /** Item content */
      content: PropTypes.node,
    }).isRequired,
  ),
};

export default SignStageItems;
